import { useId } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { useLanguage } from "@/i18n/LanguageProvider";
import { useTranslation } from "@/i18n/useTranslation";
import { cn } from "@/lib/utils";

interface LanguageToggleProps {
  className?: string;
}

export const LanguageToggle = ({ className }: LanguageToggleProps) => {
  const { language, setLanguage } = useLanguage();
  const { t } = useTranslation();
  const selectId = useId();

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <Label htmlFor={selectId} className="text-sm font-medium text-muted-foreground">
        {t("language.label")}
      </Label>
      <Select value={language} onValueChange={(value) => setLanguage(value as typeof language)}>
        <SelectTrigger id={selectId} className="w-[120px]">
          <SelectValue placeholder={t("language.english")} />
        </SelectTrigger>
        <SelectContent align="end">
          <SelectItem value="en">{t("language.english")}</SelectItem>
          <SelectItem value="th">{t("language.thai")}</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
